// extracted by css-extract-rspack-plugin
export default {"lighthouseFrame":"lZcy7"};